import axios from "axios";
import { getNodeServerUrl } from "@utils/getNodeUrl";

export const countFeedback = async ({currentmeetingid}) => {
  const headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  };

const nodeBaseUrl = getNodeServerUrl();

  const options = {
    url: `${nodeBaseUrl}/DRM_Count/countFeedback`,
    method: "post",
    headers: headers,
    data: {currentmeetingid}
  };

  try {
    const res = await axios(options);
    return res;
  } catch (error) {
    const errors = error?.response?.data?.error?.msg;
    if (errors) {
      return { error: error?.response?.data?.error?.msg };
    } else {
      return { error: "Something Went Wrong" };
    }
  }
};
